import { render, staticRenderFns } from "./CompanyModule.vue?vue&type=template&id=371d3c36&scoped=true&"
import script from "./CompanyModule.vue?vue&type=script&lang=js&"
export * from "./CompanyModule.vue?vue&type=script&lang=js&"
import style0 from "./CompanyModule.vue?vue&type=style&index=0&id=371d3c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371d3c36",
  null
  
)

export default component.exports